export default {
    about: 'About',
    becomeAModel: 'Become a Model',
    create: 'Sign Up for MyFreeCams',
    chatArchives: 'Chat Archives',
    contactSupport: 'Contact Support',
    contentRemoval: 'Content Removal',
    feedback: 'Provide Feedback',
    hiddenModels: 'Hidden Models',
    ignoredModels: 'Ignored Models',
    login: 'Log In',
    logout: 'Log Out',
    manageAccount: 'Manage Account',
    missMFC: 'Miss MFC',
    modelBrowser: 'Model Browser',
    modelsYouMayLike: 'Models You May Like',
    myAccount: 'My Account',
    mfcMail: 'MFC Mail',
    mfcShare: 'MFC Share',
    shareFeed: 'Share Feed',
    mfcMobileWebsite: 'Old Mobile Site',
    mfcDesktopWebsite: 'MFC Desktop Site',
    modelBroadcast: 'Broadcast',
    modelAdmin: 'Model Admin',
    myNotes: 'My Notes',
    news: 'News Feed',
    privateGallery: 'Private Gallery',
    purchaseTokens: 'Purchase Tokens',
    support: 'Support',
    rewardPointsInfo:
        'Customers with high reward points receive priority support, access to special features throughout the site, and a big thank you from all of the models and staff at MyFreeCams!',
    purchaseLimitInfo:
        'You are currently limited to purchasing {dailyLimit} tokens per day, and to a maximum of {totalLimit} tokens that can be stored in your account at one time.\n\nPurchase limits are restrictions on the amount of purchases that a member can make. To learn more about purchase limits as well as to request to raise these limits, please contact support.',
    wiki: 'Wiki / Help',
    groups: {
        account: 'Account',
        tokens: 'Tokens',
        alerts: 'Alerts',
        chat: 'Chat',
        lists: 'Lists',
        personal: 'Personal',
        discoverMore: 'Discover More',
        helpLegal: 'Help / Legal',
    },
    status: {
        username: 'Username',
        accountType: 'Account Type',
        activeTokenBalance: 'Active Token Balance',
        tokenStorage: 'Token Storage',
        rewardPoints: 'Reward Points',
        dailyPurchaseLimit: 'Daily Purchase Limit',
        maxTokenBalance: 'Max Token Balance',
    },
    tokenStorage: {
        description:
            'Token Storage is a way for you to set aside tokens for later use. You can instantly transfer tokens out of your Storage and into your active account. Even if you allow models to see your tokens, they will not be able to see how many tokens you have in Storage. Also, if you are in a paid session like a Private Show, the show will stop automatically once you run out of tokens in your active account.',
    },
    changePassword: {
        description:
            'Please note: upon successful password change, your session will be refreshed.',
    },
    changeUsername: {
        requirements:
            'To prevent abuse of this feature, we are restricting it only to loyal users of this site who have accumulated 1000 Reward Points and have been members for at least one month.',
        eligible:
            'Your account meets both of these qualifications. Your past usernames are reserved for 90 days, after which time other users are free to choose those usernames.',
    },
    performerNotice: 'This setting is not applicable to performer accounts.',
}
